import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import { useGetFormDataWithSpaceId } from '../useGetFormDataWithSpaceId'
import type { Error } from '@eggplant/types'
import type { ReactElement } from 'react'

export interface Props {
  values: FormData
  children: () => ReactElement
  onSuccess: () => void
  onError: (error: Error) => void
}

const CreateCustomScriptRequest = ({
  values,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/custom_scripts`

  const { requestParams } = useGetFormDataWithSpaceId(values)

  return (
    <AuthenticatedDataRequest
      children={children}
      formData={requestParams}
      isUrlEncoded
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      spinnerSize={0}
      url={url}
    />
  )
}

export default CreateCustomScriptRequest
